import { useEffect } from "react";
import { APP_ROUTES } from "../constants";
import { useRouteWithToken } from "./useRouteWithToken";
import { useSessionStore } from "../store/useSessionStore";
import { RequestStatus } from "../utils/commons";
import { isRequestPayable } from "../utils/requestGate";

/**
 * Redirects to the request-already-fulfilled gate when the linked money
 * request is no longer payable (bookmark / back-navigation guard).
 */
export function useRequestPayableGuard() {
  const { session } = useSessionStore();
  const { redirectTo } = useRouteWithToken();

  useEffect(() => {
    if (
      session.status === RequestStatus.LOADED &&
      session.data?.config &&
      !isRequestPayable(session.data.config)
    ) {
      redirectTo(APP_ROUTES.REQUEST_ALREADY_FULFILLED_PAGE, { replace: true });
    }
  }, [session.status, session.data?.config, redirectTo]);
}
